import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/advers',
      name: 'advers',
      component: () => import('./views/Advers.vue'),
    },
    {
      path: '/adversdetails/:id',
      name: 'adversdetails',
      component: () => import('./views/AdversDetails.vue'),
    },
    //公益课堂
    {
      path: '/publicclass',
      name: 'publicclass',
      component: () => import('./views/PublicClass.vue'),
    },
    {
      path: '/classdetails/:id',
      name: 'classdetails',
      component: () => import('./views/PublicClassDetails.vue'),
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('./views/Policy.vue')
    },
    {
      path: '/policydetails/:id',
      name: 'policydetails',
      component: () => import('./views/PolicyDetails.vue')
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: () => import('./views/ContactUs.vue')
    },
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter